import Login from './components/Login.vue';
import AllGames from './components/AllGames.vue';
import MyGames from './components/MyGames.vue';
import Wishlist from './components/Wishlist.vue';

export const routes = [
	{
		path: '',
		components: {
			default: AllGames,
		},
		name: 'allgames'	// optional name of the route
	},
	{
		path: '/login',
		components: {
			default: Login,
		},
		name: 'login'	// optional name of the route
	},
	{
		path: '/mygames',
		components: {
			default: MyGames,
		},
		name: 'mygames'	// optional name of the route
	},

	{
		path: '/wishlist',
		components: {
			default: Wishlist,
		},
		name: 'wishlist'	// optional name of the route
	},


	{ path: '*', redirect: '/' }	// catch all other routes which are not handled first, redirect to home
]